import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const PdfGenerator = async (
  htmlElement,
  orientationOfPdf = "landscape"
) => {
  try {
    const canvas = await html2canvas(htmlElement, {
      scale: 4,
      useCORS: true,
    });

    const imageData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: orientationOfPdf,
      unit: "mm",
      format: "a4",
      // hotfixes: ["px_scaling"],
      // autoPaging: true,
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imageData, "PNG", 0, 0, pdfWidth, pdfHeight);

    const pdfBlobUrl = pdf.output("bloburl");
    window.open(pdfBlobUrl, "_blank");
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};
